import { render } from "./UECommunicationsEditView.vue?vue&type=template&id=d13f4b84&scoped=true"
import script from "./UECommunicationsEditView.vue?vue&type=script&lang=js"
export * from "./UECommunicationsEditView.vue?vue&type=script&lang=js"

import "./UECommunicationsEditView.vue?vue&type=style&index=0&id=d13f4b84&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d13f4b84"]])

export default __exports__